/**
 * Development Councils Translations (Japanese)
 * @module developmentCouncils
 * @language ja
 */

export const developmentCouncils = {
  developmentCouncils: {
    title: "JCI開発評議会",
    subtitle: "成長と発展のための4つの地域柱",
    description: "JCIエリア開発評議会は、JCI理事会およびJCI本部と協力して、リーダーシップ開発、組織成長、持続可能なインパクトのための地域柱として世界中で活動しています。",

    heroBadge: "JCIグローバル拡大",
    networkGrowthBadge: "JCIネットワーク成長",

    overview: {
      title: "グローバル概要",
      description: "これらの評議会はJCIの戦略的地理的区分を代表し、変化する世界のためのリーダーを育成するために協力しています。",
      councilsCount: "4つのエリア評議会",
      regionsServed: "全大陸"
    },

    sections: {
      mission: "ミッション",
      strategicGoals: "2025年戦略目標",
      keyAchievements: "主要達成事項",
      keyMetrics: "主要指標",
      recommendations: "2026年への提言",
      highlights: "2025年ハイライト"
    },

    councils: {
      adc: {
        name: "アメリカ開発評議会",
        abbreviation: "ADC",
        region: "アメリカ",
        mission: "JCIブランドの認知度を高め、会員の成長と維持を促進し、メンバーにグローバルな開発リーダーシップ経験を提供する活動を展開します。",
        goals: {
          brandAwareness: {
            name: "ブランド認知と可視性",
            description: "ソーシャルメディアプラットフォームでのエンゲージメントを高め、JCI活動を促進する。",
            achievements: [
              "ソーシャルメディアエンゲージメント30%増加",
              "JCI Lead Magazineに2記事掲載",
              "戦略的タグとインタラクションの改善"
            ]
          },
          leadershipDevelopment: {
            name: "リーダーシップ開発",
            description: "アメリカ地域全体で新しいリーダーを育成する。",
            achievements: [
              "全国会長会議に68%参加（17名の会長）",
              "アメリカンリーダーシップアカデミー25周年、77%参加",
              "30時間以上のコンテンツで27名の新リーダーを育成",
              "8セッションのリーダーシップトレーニングプログラム"
            ]
          },
          sustainableStructure: {
            name: "オープンで効率的かつ持続可能な組織",
            description: "各国組織の発展と拡大を支援する。",
            achievements: [
              "チリがJCI候補組織として提示",
              "グアテマラが暫定ステータスに向けて支援",
              "ジュニアクラブカンファレンス250名登録"
            ]
          }
        },
        metrics: {
          socialMedia: { label: "ソーシャルメディア成長", value: "30%" },
          membership: { label: "会員目標", value: "5%" },
          bestPractices: { label: "ベストプラクティス調査", value: "834" },
          leadersTrained: { label: "育成リーダー数", value: "27" }
        },
        highlights: [
          "アメリカンリーダーシップアカデミー25周年記念",
          "ベストプラクティス共有のための初のオンライングローバルイベント",
          "ADCリーダーシップによるジュニアクラブカンファレンス開始"
        ]
      },
      edc: {
        name: "ヨーロッパ開発評議会",
        abbreviation: "EDC",
        region: "ヨーロッパ",
        mission: "ヨーロッパ41地域の各国組織間で成長、イノベーション、コラボレーションを支援する文化を育成します。",
        goals: {
          valueProposition: {
            name: "価値提案",
            description: "18-40歳層をターゲットとした四半期ごとのソーシャルメディアキャンペーンを作成する。",
            achievements: [
              "1月〜11月で+8,896人の新規フォロワー",
              "9,789件の投稿を公開",
              "5,176件のリシェアを達成"
            ]
          },
          geographicExpansion: {
            name: "地理的拡大",
            description: "新しい地域でJCIのプレゼンスを確立する。",
            achievements: [
              "目標：第3四半期までに3つの新地域",
              "新しい候補組織を支援",
              "既存の各国組織内での拡大"
            ]
          },
          knowledgeSharing: {
            name: "知識共有",
            description: "相互コラボレーションを可能にするプログラムを組織する。",
            achievements: [
              "4つの知識共有プログラムを開催",
              "ASEとの協力でメンタリングプログラムを刷新",
              "24のメンティーチームが登録"
            ]
          },
          productDevelopment: {
            name: "新製品開発",
            description: "持続可能なローカルチャプター開発のためのツールを立ち上げる。",
            achievements: [
              "JCIシリアスゲームを開発・テスト",
              "7カ国がプロトタイプテストに参加",
              "平均満足度スコア4.5/5"
            ]
          }
        },
        metrics: {
          followers: { label: "新規フォロワー", value: "+8,896" },
          academyParticipants: { label: "アカデミー参加者", value: "158+" },
          gameSatisfaction: { label: "ゲーム満足度", value: "4.5/5" },
          regionsCovered: { label: "カバー地域数", value: "41" }
        },
        highlights: [
          "JCIシリアスゲームのプロトタイプを7カ国でテスト",
          "地中海リーダーシップアカデミー（31名参加）",
          "スウェーデンでのヨーロッパアカデミー（99名参加）",
          "トライネーションズアカデミー（アイルランド、英国、スコットランド）",
          "バルカンアカデミー（7カ国、14名参加）"
        ]
      },
      amdec: {
        name: "アフリカ・中東開発評議会",
        abbreviation: "AMDEC",
        region: "アフリカおよび中東",
        mission: "リーダーシップ開発、戦略的パートナーシップ、革新的なソリューションを通じて、アフリカと中東の若い起業家的リーダーがポジティブな変化を推進できるよう支援します。",
        goals: {
          anniversary: {
            name: "40周年記念",
            description: "地域全体での40年間のインパクトとリーダーシップを祝う。",
            achievements: [
              "40年のインパクトデジタルキャンペーン開始",
              "過去と現在のリーダーの表彰式",
              "AMDECの遺産を継続するためのイニシアチブ"
            ]
          },
          skillsDevelopment: {
            name: "トレーニングとスキル開発",
            description: "主要な運営分野に関する月次トレーニングを実施する。",
            achievements: [
              "財務管理と予算編成トレーニング",
              "効果的な会議と議会手続き",
              "プロジェクト管理とインパクト評価",
              "パーソナルブランディングとリーダーシップ開発"
            ]
          },
          strategicCollaboration: {
            name: "戦略的コラボレーション",
            description: "言語の壁を埋め、地域間のコラボレーションを促進する。",
            achievements: [
              "ポルトガル語圏諸国向けJCIルソフォンシリーズ開始",
              "ジュニアクラブカンファレンスにオンライン100名以上参加",
              "EDCおよびJCIフランスとのパートナーシップでJCIゲームシリーズ"
            ]
          }
        },
        metrics: {
          yearsOfImpact: { label: "インパクトの年数", value: "40" },
          newMarkets: { label: "新規市場", value: "2" },
          conferenceAttendees: { label: "カンファレンス参加者", value: "100+" },
          trainingTopics: { label: "トレーニングトピック", value: "4+" }
        },
        highlights: [
          "地域全体での40周年記念",
          "モーリシャスでの全国会長会議",
          "第27回JCIアフリカ・中東アカデミー",
          "ポルトガル語圏諸国を結ぶJCIルソフォンシリーズ",
          "ケニアが政府登録のマイルストーンを達成"
        ]
      },
      apdc: {
        name: "アジア太平洋開発評議会",
        abbreviation: "APDC",
        region: "アジアおよび太平洋地域",
        mission: "JCIのミッションを通じて、JCIのプレゼンスを拡大し、地域発展のポジティブな要因として活動します。",
        goals: {
          strategicPlan: {
            name: "戦略計画の実行",
            description: "JCI行動フレームワークと2023-2027戦略計画を共有・実行する。",
            achievements: [
              "ターゲット国への12のミッションを実施",
              "他の開発評議会とのコラボレーション",
              "四半期ごとの会議を通じた構造化された計画"
            ]
          },
          countryEmpowerment: {
            name: "国別エンパワーメント",
            description: "担当国の加盟または卒業に向けてエンパワーする。",
            achievements: [
              "6つの新しいローカル組織が加盟",
              "1つの国家組織が宣言",
              "356名以上の会員を募集",
              "管理と財務における持続可能な基盤"
            ]
          },
          countryDevelopment: {
            name: "国別開発",
            description: "各国に対するターゲット開発プログラム。",
            achievements: [
              "タイ：会員20%成長（150→180）",
              "ミャンマー：地震救援で11,000米ドル調達",
              "スリランカ：復活後初の全国大会",
              "ウズベキスタン：46から60名に成長"
            ]
          }
        },
        metrics: {
          membersRecruited: { label: "募集会員数", value: "356+" },
          newLocalOrgs: { label: "新規ローカル組織", value: "6" },
          missionsConducted: { label: "実施ミッション数", value: "12" },
          nationalOrgs: { label: "国家組織", value: "1" }
        },
        highlights: [
          "JCIタイが持続可能性パフォーマンス指数85%を達成",
          "ミャンマー地震救援プロジェクトで500名以上を支援",
          "スリランカが初の全国大会を開催",
          "東ティモールが9つのパートナー組織と連携",
          "ラオスがYEALパートナーシップで開発を開始"
        ]
      }
    },

    comparativeAnalysis: {
      title: "比較分析",
      subtitle: "4つの評議会が主要次元でどのように比較されるか",
      categories: {
        geographicCoverage: {
          name: "地理的カバレッジ",
          adc: "中南米、カリブ海、北米",
          edc: "大学センターを中心とした41地域",
          amdec: "40年以上の地域プレゼンス",
          apdc: "ミャンマー、タイ、スリランカ、東ティモール、ウズベキスタン、ラオス"
        },
        strategicPriorities: {
          name: "戦略的優先事項",
          adc: "ソーシャルメディアによるブランド可視性、会員成長目標",
          edc: "地理的拡大、知識共有、革新的製品",
          amdec: "組織的遺産、基礎構造、新市場",
          apdc: "国別エンパワーメント、ターゲットミッション、能力構築"
        },
        leadershipDevelopment: {
          name: "リーダーシップ開発",
          adc: "全国会長会議、アメリカンリーダーシップアカデミー",
          edc: "地域アカデミー、メンタリングプログラム、シリアスゲーム",
          amdec: "リーダーシップアカデミー、月次トレーニング、メンターシップ",
          apdc: "国別ミッション、専門ワークショップ"
        }
      }
    },

    keyHighlights: {
      title: "2025年主要ハイライト",
      subtitle: "全評議会の主要な達成とイノベーション",
      items: {
        seriousGame: {
          title: "JCIシリアスゲーム",
          description: "EDCが開発したインタラクティブ学習ツール、7カ国でテストし満足度4.5/5を達成。"
        },
        juniorClub: {
          title: "ジュニアクラブカンファレンス",
          description: "250名以上の登録を集めた評議会間イニシアチブ、若いJCI志望者にインスピレーションを与える。"
        },
        anniversary: {
          title: "AMDEC 40周年",
          description: "デジタルキャンペーンと表彰式で40年のインパクトを祝う。"
        },
        apdcGrowth: {
          title: "APDC成長マイルストーン",
          description: "356名以上の会員募集、6つの新しいローカル組織が加盟、12の戦略的ミッションを実施。"
        },
        lusophoneSeries: {
          title: "JCIルソフォンシリーズ",
          description: "アンゴラ、カーボベルデ、ギニアビサウなどのポルトガル語圏諸国を結ぶ。"
        }
      }
    },

    newNationalOrganizations: {
      title: "新規国家組織",
      subtitle: "新興JCIコミュニティによるグローバルネットワークの拡大",
      potential: {
        title: "候補",
        description: "JCI加盟を検討し、基礎的な組織構造を確立中"
      },
      provisional: {
        title: "暫定",
        description: "会員基盤を構築し、正式加盟のためのJCI基準を満たす段階"
      },
      fullAffiliation: {
        title: "正式加盟",
        description: "JCIグローバルネットワークの正式メンバーとして最近認定"
      },
      countries: {
        angola: "JCIアンゴラ",
        djibouti: "JCIジブチ",
        chile: "JCIチリ",
        gambia: "JCIガンビア",
        sriLanka: "JCIスリランカ",
        portugal: "JCIポルトガル",
        myanmar: "JCIミャンマー",
        armenia: "JCIアルメニア"
      }
    },

    chairperson: "議長",
    learnMore: "詳しく見る",
    viewDetails: "詳細を見る",
    source: "出典：JCI開発評議会2025年包括レポート"
  }
} as const;
